import { render } from "./loader-error.vue?vue&type=template&id=26213040"
import script from "./loader-error.vue?vue&type=script&lang=js"
export * from "./loader-error.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__